export default {
    nav: ''
}